import { getAuthConnection, getAuthConnectionWithNoTimeOut } from "./config.js";

export function getProjectList(query) {
  return getAuthConnection().get(`project/?${query}`);
}

export function getProject(id) {
  return getAuthConnection().get(`project/${id}`);
}

export function saveProject(data) {
  return getAuthConnection().post("project/", data);
}

export function putProject(id, data) {
  return getAuthConnection().put(`project/${id}/`, data);
}

export function patchProject(id, data) {
  return getAuthConnection().patch(`project/${id}/`, data);
}

export function getTaskList(query) {
  return getAuthConnection().get(`task/?${query}`);
}

export function getTask(id) {
  return getAuthConnection().get(`task/${id}`);
}

export function saveTask(data) {
  return getAuthConnection().post("task/", data);
}

export function updateTask(id, data) {
  return getAuthConnection().patch(`task/${id}/`, data);
}

export function getItem(id) {
  return getAuthConnection().get(`item/${id}`);
}

export function postTaskItemHide(data) {
  return getAuthConnection().post(`taskitemhide/`, data);
}

export function deleteTaskItemHide(id) {
  return getAuthConnection().delete(`taskitemhide/${id}/`);
}

export function postTaskShow(id, data) {
  if (!id) {
    id = 0;
  }
  return getAuthConnection().post(`task/${id}/show`, data);
}

export function delTaskShow(id, data) {
  return getAuthConnection().delete(
    `task/${id}/show?id=${data.id}&featureId=${data.featureId}`
  );
}

export function getReleaseList(query) {
  return getAuthConnection().get(`release?${query}`);
}

export function getRelease(id) {
  return getAuthConnection().get(`release/${id}`);
}

export function postRelease(data) {
  return getAuthConnectionWithNoTimeOut().post("release", data);
}

export function updateTaskClusterPositions(data) {
  return getAuthConnection().post("task/clusters/positions", data);
}
